import React, { Fragment, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SimpleTextModal from "../modals/SimpleTextModal";

const PrivacyPolicy = (props) => {
    const { t } = useTranslation();
    const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false);

    return (
        <Fragment>
            <Button variant="link" onClick={() => setShowPrivacyPolicyModal(true)}>
                {t("privacyPolicy")}
            </Button>
            {showPrivacyPolicyModal && <SimpleTextModal title={t("privacyPolicy")} txt={<></>} onClose={() => setShowPrivacyPolicyModal(false)} show={true} />}
        </Fragment>
    );
};

export default PrivacyPolicy;
